import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, input, ElementRef, ViewChild, viewChild, effect } from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { OfferProduct } from '../../models/offer-product.model';
import { CommonModule } from '@angular/common';
import { ProductCardComponent } from '../product-card/product-card.component';
import { A11y, Navigation, Pagination } from "swiper/modules";
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-carousel',
  imports: [CommonModule, ProductCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent implements OnInit {
  products = input.required<OfferProduct[]>();
  title = input<string>();
  slidesToShow = input<number>(0);
  swiperContainer = viewChild.required<ElementRef<SwiperContainer>>('swiperContainer');
  // nextBtn = viewChild.required<ElementRef<HTMLButtonElement>>('nextBtn');
  // prevBtn = viewChild.required<ElementRef<HTMLButtonElement>>('prevBtn');

  isEnd: boolean = false;
  // @ViewChild('nextBtn', { static: true })
  // nextBtn!: ElementRef<HTMLButtonElement>;
  // @ViewChild('prevBtn', { static: true })
  // prevBtn!: ElementRef<HTMLButtonElement>;  
  // nextBtnRef!: ElementRef<HTMLButtonElement>;
  // prevBtnRef!: ElementRef<HTMLButtonElement>;

  swiperOptions: SwiperOptions = {
    initialSlide: 1,
    navigation: {
      // nextEl: '.carousel-products__next',
      // prevEl: '.carousel-products__prev',
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerGroup: 3,
    pagination: {
      clickable: true,
    },
    modules: [A11y, Navigation, Pagination],
    spaceBetween: 0,
    breakpoints: {
      280: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        pagination: {
          dynamicBullets: true,
          clickable: false,
          enabled: true,
        },
      },

      480: {
        slidesPerView: 2,
        pagination: {
          clickable: false,
          enabled: false,
        },
      },

      768: {
        slidesPerGroup: 2,
        slidesPerView: this.slidesToShow() ? this.slidesToShow() - 2 : 3,
        // slidesPerView: 6,
        pagination: {
          clickable: false,
          enabled: false,
        },
      },
      // when window width is >= 860px
      860: {
        slidesPerView: this.slidesToShow() ? this.slidesToShow() - 2 : 4,
        // slidesPerView: 6,
        pagination: {
          clickable: false,
          enabled: false,
        },
      },
      // when window width is >= 1024px
      1240: {
        slidesPerGroup: 3,
        slidesPerView: this.slidesToShow() ? this.slidesToShow() - 1 : 5,
        pagination: {
          clickable: false,
          enabled: false,
        },
      },
      1680: {
        slidesPerView: this.slidesToShow() ? this.slidesToShow() : 6,
        pagination: {
          clickable: false,
          enabled: false,
        },
      },
    },
  };

  constructor() {
    effect(() => {
      if (this.products().length > 0) {
        const swiperEl = this.swiperContainer().nativeElement;
        Object.assign(swiperEl, this.swiperOptions);
        if(swiperEl.initialize instanceof Function) {
          swiperEl.initialize();
        }
      }
    });
  }

  ngOnInit(): void {
    // console.log("swiper options: ", this.swiperOptions);
    // Initialize any necessary data or settings
  }

  changeHandler(): void {
    if (this.isEnd) {
      // this.nextBtn().nativeElement.style.display = 'block';
    }
  }

  endHandler(): void {
    // this.nextBtn().nativeElement.style.display = 'none';
    this.isEnd = true;
  }

  beginHandler(): void {
    // this.prevBtn().nativeElement.style.display = 'none';
  }

  onNextClick(): void {
    // this.prevBtn().nativeElement.style.display = 'block';
  }

  onPrevClick(): void {
    // this.nextBtn().nativeElement.style.display = 'block';
  }
}
